import { useState, ReactNode, createContext, useCallback } from 'react';

interface RoomAsset {
  [key: string]: any;
}

export const RoomAssetsContext = createContext<{
  asset: RoomAsset;
  updateAsset: (asset: RoomAsset) => void;
}>({
  asset: {},
  updateAsset: () => {},
});

export const RoomAssetsProvider = ({ children }: { children: ReactNode }) => {
  const [asset, setAsset] = useState<RoomAsset>({});

  const updateAsset = useCallback((newAsset: RoomAsset) => {
    setAsset(newAsset);
  }, []);

  return (
    <RoomAssetsContext.Provider value={{ asset, updateAsset }}>
      {children}
    </RoomAssetsContext.Provider>
  );
};
